// extracted by mini-css-extract-plugin
module.exports = {"slider_li_class":"sliderCard_slider_li_class__MslGp","h2":"sliderCard_h2__4RBdR"};